const code = [
  {
    label: '中国大陆(China)',
    value: '86'
  },
  {
    label: '香港(Hong Kong)',
    value: '852'
  },
  {
    label: '澳门(Macao)',
    value: '853'
  }
]

export default code
